"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviouslyConfirmedOrderLineVersion = void 0;
const helpers_1 = require("../../helpers");
const getPreviouslyConfirmedOrderLineVersion = (versions) => {
    if (!versions || versions.length === 0)
        return null;
    if (versions.length === 1)
        return null; // if there is only 1 version tehre is no previous version
    // the latest version is the one with the newest created_at date
    versions = versions.filter((version) => version.status === helpers_1.OrderLineStatus.CONFIRMED);
    return versions.sort((a, b) => {
        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
    })[0];
};
exports.getPreviouslyConfirmedOrderLineVersion = getPreviouslyConfirmedOrderLineVersion;
